<template>
    <div>
        <div>
            <dv5-right-banner
                :view="rightBannerProp" :app="view.app" :translation="view.resources_facebook"
                v-show="windowWidth > 700 && view.father_is_builderall && view.banner_dashboard_right !== undefined && view.banner_dashboard_right !== null"
            />
        </div>
        <div>
            <dv5-right-banner-vip
                v-show="view.father_is_builderall && showVipBanner"
                :vip_banner_infos="VipBannerData" :version="version" :is_vip="view.is_vip" :support_route="view.support_route"
                :routes="view.handler_routes" :is_free_plan="view.is_free_plan" :app="this.view.app"
            />
        </div>
        <div class="separator" />
        <!-- [2023-07-03] Commented the Feature Tutorials board and updated the side banner by @carloseduarodorcha -->
        <!-- <div v-show="view.is_subsidiary_brazil" class="content CardBase">
            <div class="TitleCard">
                {{ Title }}
            </div>
            <br />
           < !-- <iframe :src='iFrame' />
                data.id -- >
            <card-tutorial class="Content" v-for="(data, index) in results" :key="index" :view="data" :routes="view.handler_routes" :upgrade="view.translation.label_require_upgrade" :version="version" :is_free_plan="view.is_free_plan"/>
        </div>
        <div>
            <dv5-right-special-banners
                v-show="view.father_is_builderall && !view.is_subsidiary_brazil"
                :srcImg="view.top_affiliate_banner_url"
                :actionLink="view.top_affiliate_banner_action_link"
            />
        </div> -->
        <div>
            <dv5-right-special-banners
                v-show="view.father_is_builderall"
                :srcImg="view.special_banner_path"
                :actionLink="view.special_banner_link"
            />
        </div>
    </div>
</template>


<script>
import CardBtn from './components/CardBtn.vue';
import CardTutorial from './components/CardTutorial.vue';

export default {
  components: { CardTutorial, CardBtn },
    name: "dv5-tutorial",
    props: ["view"],
    data() {
        return {
            Title: 'Feature Tutorial',
            iFrame: null,
            windowWidth: window.innerWidth,
            keywords: null,
            results: [],
            amount: 10,
            resultsSuggestion: [],
            version: this.view['version'],
            rightBannerProp: null,
            VipBannerData: null,
            showVipBanner: null
        };
    },

    mounted() {
        this.version = this.view['version'];
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
        // if (this.view.app == 'banners_ba5') {
        let rightBannerProp = JSON.parse(this.view.banner_dashboard_right)
        this.rightBannerProp = rightBannerProp.RIGHT
        this.VipBannerData = rightBannerProp.SUPPORT
        // } else {
        //     this.rightBannerProp = this.view.banner_dashboard_right
        //     this.VipBannerData = this.view.vip_banner_infos
        // }
        this.vipBannerVerification();
    },
    created: async function() {
        this.mountLinkIframe();
        // try {
        //     this.email = this.view.email;
        //     this.lang = this.view.lang;
        //     let response = await axios.get(`https://intelligence.builderall.com/contents/` + this.lang + `/` + this.email);
        //     if(response.data.error) {
        //         throw response.data.message
        //     } else {
        //         this.results = response.data
        //     }
        // } catch (e) {
        //     console.log(e);
        // } finally {
        //     if(this.results !== undefined && this.results !== null && this.results.length == 0) {
        //         try {
        //             let response2 = await axios.get(`https://intelligence.builderall.com/contents/us/` + this.email);
        //             if(response2.data.error) {
        //                 throw response2.data.message
        //             } else {
        //                 this.results = response2.data
        //             }
        //         } catch (e) {
        //             console.log(e);
        //         }
        //     }

        //     this.setToolSuggestion();
        // }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        mountLinkIframe() {
            // if (this.view.lang == 'br') {
            //     this.iFrame = 'https://wizard.builderall.com/lateral/br/' + this.view.email;
            //     console.log(this.iFrame)
            // } else {
            //     this.iFrame = "https://wizard.builderall.com/lateral/us/" + this.view.email;
            //     console.log(this.iFrame)
            // }
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
        loadMore() {
            this.$Progress.start();
            setTimeout(() => {
                this.amount += 10;
                this.$Progress.finish();
            }, 400);
        },
        setToolSuggestion() {
            let vm = this,
                toolSuggestion = [];

            this.results.forEach(function(val){
                if(val.group && val.group.hasOwnProperty('img') && val.group.img != null && val.group.img.length){

                    let tool = vm.getToolByIcon(val.group.img);
                    if(tool) {
                        if(toolSuggestion.indexOf(tool.id) === -1){
                            toolSuggestion.push(tool.id);
                        }
                    }
                }
            });

            if(toolSuggestion.length) {
                localStorage.setItem('toolSuggestion', toolSuggestion.join());
            }
        },
        getToolByIcon(icon) {
                let tool = this.view.tools.filter(function(_tool) {
                if(_tool.icon && _tool.icon.length){
                    let reg = new RegExp(_tool.icon);
                    return reg.test(icon);
                }
            });

            tool = tool.length ? tool[0] : false; // if find then return tool infos, else return false
            return tool;
        },
        vipBannerVerification() {

            if (typeof this.VipBannerData == 'object') {
                if(Object.keys(this.VipBannerData).length > 0) {
                    this.showVipBanner = true;
                }
            } else if (this.VipBannerData.length > 0) {
                this.showVipBanner = true;
            }
        }
    },
    filters: {
    },
    computed: {
    },
    watch: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../../scss/extras/_variables';
.CardBase {
    padding: 15px;
    background-color: $dv5-color4;
    box-shadow: 1px 1px 1px #dbdee2;
    border-radius: 4px;

    max-height: 50vh;
    overflow-x: auto;
}
.Content {
    font: inherit;
    margin: 0 auto;
    text-align: left;
    max-width: 100%;
}
.TitleCard {
    font-size: 16px;
    font-weight: bold;
}
.SupportBtn {
    padding-bottom: 20px;
    padding-top: 20px;
}
iframe {
    border: none;
    height: 100vh;
}

@media only screen and (max-width: 600px) {
    .header,
    .content{
        font: inherit;
        margin: 0 auto;
        text-align: left;
        max-width: 100%;
    }
    iframe {
    border: none;
    height: 100vh;
    width: 100%;
}
}
@media only screen and (max-width: 700px) {
    .separator {
        background-color: #707070;
        height: 1px;
        width: 100%;
        opacity: 0.6;
        margin: 1em 0;
    }
}

</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/tutorial/index.vue